import './reducers/account.reducer';
import './reducers/purchase.reducer';
import './reducers/ipCountryCode.reducer';
import './reducers/tab.reducer';
import './reducers/toasts.reducer';
import './reducers/userAgent.reducer';
import './reducers/catalog.reducer';
import './reducers/product.reducer';

export {default as accountActions, AccountTypes} from './actions/account.actions';
export {default as appActions, TYPES as AppTypes} from './actions/app.actions';
export {
    default as catalogActions,
    TYPES as CATALOG_TYPES,
    CatalogParams
} from './actions/catalog.actions';
export {
    default as productActions,
    TYPES as ProductTypes,
    AutoUpdateSettingParamsPayload,
    AutoUpdateSettings,
    ProductAction,
    ProductParams,
    ProductParamsPayload
} from './actions/product.actions';
export {default as protocolActions, TYPES as ProtocolTypes} from './actions/protocol.actions';
export {default as purchaseActions, TYPES as PurchaseTypes} from './actions/purchase.actions';
export {default as searchActions, SearchActionTypes} from './actions/search.actions';
export {default as tabActions, TYPES as TabTypes} from './actions/tab.actions';
export {default as toastActions, TYPES as ToastTypes} from './actions/toast.actions';

// apis
export {default as AccountApi} from './api/AccountApi';
export {default as CatalogApi} from './api/CatalogApi';

// selectors
import * as account from './selectors/account.selectors';
import * as app from './selectors/app.selectors';
import * as catalog from './selectors/catalog.selectors';
import * as localization from './selectors/localization.selectors';
import * as product from './selectors/product.selectors';
import * as purchase from './selectors/purchase.selectors';
import * as router from './selectors/router.selectors';
import * as search from './selectors/search.selectors';

// utils
import * as sagaUtils from './utils/sagaUtils';

// exports
export const accountSelectors = account;
export const appSelectors = app;
export const catalogSelectors = catalog;
export const localizationSelectors = localization;
export const productSelectors = product;
export const purchaseSelectors = purchase;
export const routerSelectors = router;
export const searchSelectors = search;

export const utils = {
    ...sagaUtils
};
